module.exports = __webpack_public_path__ + "img/ap-logo.fc5d1e91.svg";